<template>
  <button
    :class="['base-btn', `btn-${type}`, `btn-${size}`, { 'btn-block': block, 'btn-disabled': disabled }]"
    :disabled="disabled || loading"
    @click="$emit('click', $event)"
  >
    <span v-if="loading" class="btn-loading"></span>
    <slot></slot>
  </button>
</template>

<script>
export default {
  name: 'BaseButton',
  props: {
    type: {
      type: String,
      default: 'primary',
      validator: (value) => ['primary', 'secondary', 'outline', 'text', 'gold'].includes(value)
    },
    size: {
      type: String,
      default: 'medium',
      validator: (value) => ['small', 'medium', 'large'].includes(value)
    },
    block: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped>
.base-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  border: none;
  border-radius: 4px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s;
  white-space: nowrap;
}

/* Sizes */
.btn-small {
  padding: 6px 16px;
  font-size: 12px;
}

.btn-medium {
  padding: 10px 24px;
  font-size: 14px;
}

.btn-large {
  padding: 14px 36px;
  font-size: 16px;
}

.btn-block {
  display: flex;
  width: 100%;
}

/* Types */
.btn-primary {
  background: #1a1a1a;
  color: #fff;
}

.btn-primary:hover {
  background: #333;
}

.btn-secondary {
  background: #d4af37;
  color: #1a1a1a;
}

.btn-secondary:hover {
  background: #c4a032;
}

.btn-outline {
  background: transparent;
  color: #1a1a1a;
  border: 1px solid #1a1a1a;
}

.btn-outline:hover {
  background: #1a1a1a;
  color: #fff;
}

.btn-text {
  background: transparent;
  color: #d4af37;
  padding-left: 0;
  padding-right: 0;
}

.btn-text:hover {
  color: #c4a032;
}

.btn-gold {
  background: #d4af37;
  color: #1a1a1a;
}

.btn-gold:hover {
  background: #c4a032;
  transform: translateY(-2px);
}

/* Disabled */
.btn-disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.btn-disabled:hover {
  transform: none;
}

/* Loading */
.btn-loading {
  width: 16px;
  height: 16px;
  border: 2px solid transparent;
  border-top-color: currentColor;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
</style>
